import { Box, Flex, Text, Button, Fade, Heading } from '@chakra-ui/react';
import DownloadMenu from '@pages/UploadSellout/components/downloadMenu';
import PopUpNotification from '@pages/UploadSellout/components/popUpNotification';
import { useUploadStore } from '@pages/UploadSellout/helpers/mainState';
import SpannedText from '@pages/UploadSellout/components/spannedText';
import FileUploadField from '@components/fileUploadField';
import { ChevronRightIcon, RepeatIcon } from '@chakra-ui/icons';
import UploadPopUp from '@pages/UploadSellout/components/uploadPopUp';
import React, { useEffect } from 'react';
import { usePopUpStore } from '@pages/UploadSellout/components/uploadPopUp/state';

const Upload = () => {
    const fileState = useUploadStore();
    const modalState = usePopUpStore();
    const accessFile = fileState.file ?? null;

    const onChangeFile = ({ selectedFile, checkedStatus }) => {
        if (checkedStatus === 'not-valid') return;
        fileState.onChangeUploadStore({ file: selectedFile });
        handleOpenModal();
    };

    const handleOpenModal = () => {
        modalState.onChangePopUpStore({ isOpen: true });
    };

    const onFileError = (message) => {
        fileState.onChangeUploadStore({
            file: null,
            isFileError: message,
        });
    };

    const handleReset = () => {
        fileState.onResetUploadtore();
        modalState.onResetPopUpStore();
    };

    useEffect(() => {
        return () => {
            handleReset();
        };
    }, []);

    return (
        <Box mb={'40px'}>
            <Flex justifyContent={'space-between'} alignItems={'center'} mb={'24px'} gap={'1rem'}>
                <Box>
                    <Heading fontWeight={'600'} fontSize={'20px'} mb={'8px'}>
                        Upload Massal
                    </Heading>

                    <Text fontSize={'14px'}>
                        Pelajari cara upload data sell out dengan menonton
                        <SpannedText url={'https://www.paragon-innovation.com/'}>video tutorial</SpannedText> atau
                        <SpannedText url={'https://www.paragon-innovation.com/'}>panduan upload.</SpannedText>
                    </Text>
                </Box>

                <Box zIndex={'9'}>
                    <Fade in={!accessFile} initialScale={0.95}>
                        {!accessFile && <DownloadMenu />}
                    </Fade>

                    <Fade in={accessFile} initialScale={0.95}>
                        {accessFile && (
                            <Flex gap={'1rem'}>
                                <Button variant="outline" onClick={handleReset}>
                                    <RepeatIcon fontSize="1.3rem" />
                                    Reset Upload
                                </Button>

                                <Button onClick={handleOpenModal}>
                                    Lanjutkan Upload
                                    <ChevronRightIcon fontSize="1.3rem" />
                                </Button>
                            </Flex>
                        )}
                    </Fade>
                </Box>
            </Flex>

            <FileUploadField
                isWhiteBg
                selectedFile={[fileState.file]}
                fileTypes={fileState.fileTypes}
                maxFileSize={fileState.maxFileSize}
                errorMessage={fileState.isFileError}
                onFileChange={(selectedFile) => {
                    onChangeFile({ selectedFile });
                }}
                onFileError={(message) => {
                    onFileError(message);
                }}
                onSizeError={(message) => {
                    onFileError(message);
                }}
                onFileReset={handleReset}
            />

            {/* modal */}
            <UploadPopUp />
            <PopUpNotification />
        </Box>
    );
};

export default Upload;
